module.exports = function(app) {

    require('./message-center/messageCenter')(app);
    require('./message-center/contactUs')(app);

    require('./../local-services/messageCenterService')(app);
    //require('./../local-services/openAttachment')(app);

    app.controller('pages.messageCenter', ['$scope', '$state', 'messageCenterService', 'storage', '$filter', 'coremetrics', 'updateVisited', '$location', '$cookies', 'services','$window', function ($scope, $state, messageCenterService, storage, $filter, coremetrics, updateVisited, $location, $cookies, services,$window) {
            $scope.headings = "Message Center";
            $scope.backAction = function() {
                $window.history.back();
            };
            $scope.backText = "Back";
    }]
    );

    return [
        {
            state: "message",
            postPassword: true,
            appConfigMaintenanceApp: 'MESSAGE_CENTER',
            appConfigMaintenanceKey: 'FULL_MAINTENANCE',
            url: "/msg",
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/categoryCustom.html'],
                    controller: "pages.messageCenter"
                },
                'content@message': {
                   // template: require('chmhom/pages/message-center/messageCenter.html'),
                    templateUrl: 'msg.appTemplate.html/chmhom/pages/message-center/messageCenter',
                    controller: "pages.message-center.messageCenter"
                }

            }
        },
         {
             state: "message.contactUs",
             postPassword: true,
             appConfigMaintenanceApp: 'MESSAGE_CENTER',
             appConfigMaintenanceKey: 'CONTACT_US_MAINTENANCE',
             url: "/contact-us",
             views: {
                 'body@': {
                     template: bootstrap.templates['page-templates/categoryDetail.html'],
                   //  controller: "pages.messageCenter"
                    // controller: "pages.message-center.contactUs"
                     controller: ['$scope','$window','$location',function($scope,$window,$location){

                         $scope.headings = "contact us";
                         if ($location.search().reply) {
                             $scope.headings = "message center";
                         }
                         $scope.backAction = function() {
                             $window.history.back();
                         };
                         $scope.backText = "Back";
                     }]
                 },
                 'content@message.contactUs': {
                    // template: require('chmhom/pages/message-center/contactUs.html'),
                     templateUrl: 'msg/contact-us.appTemplate.html/chmhom/pages/message-center/contactUs',
                     controller: "pages.message-center.contactUs"
                 },
                 'leftColumn@message.contactUs': {

                 }

             }
         },
        {
            state: "message.readMore",
            postPassword: true,
            appConfigMaintenanceApp: 'MESSAGE_CENTER',
            url: "/read-more",
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/detailCustom.html'],
                    controller: "pages.messageCenter"
                },
                'content@message.readMore': {
                  //  template: require('chmhom/pages/message-center/msgReadMore.html'),
                    templateUrl: 'msg/read-more.appTemplate.html/chmhom/pages/message-center/msgReadMore',
                    controller: "pages.message-center.messageCenter"
                },
                'leftColumn@message.readMore': {

                }

            }
        }

    ];
}
